define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        cpfValido: function (cpf) {
            cpf = cpf.replace(/[^\d]+/g, '');
            if (cpf == '')
                return false;
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return false;
            var add = 0;
            for (var i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            var rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            add = 0;
            for (var i = 0; i < 10; i++)
                add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        },
        cnpjValido: function (cnpj) {
            if (!cnpj)
                return false;
            var normalizedCnpj = normalizeCnpj(cnpj);
            if (!/^[0-9A-Z]{12}\d{2}$/.test(normalizedCnpj))
                return false;
            if (hasOnlyRepeatedChars(normalizedCnpj))
                return false;
            var digits = normalizedCnpj.slice(12);
            var digit0 = validCalc(12, normalizedCnpj);
            if (digit0 !== Number(digits[0]))
                return false;
            var digit1 = validCalc(13, normalizedCnpj);
            return digit1 === Number(digits[1]);
        },
        cnpjNormalizado: function (cnpj) { return normalizeCnpj(cnpj); }
    };
    function normalizeCnpj(value) {
        if (value === void 0) { value = ''; }
        return value.toString().replace(/[.\/\-\s]/g, '').toUpperCase();
    }
    function hasOnlyRepeatedChars(value) {
        for (var i = 1; i < value.length; i++) {
            if (value[i] !== value[0])
                return false;
        }
        return true;
    }
    function validCalc(x, cnpj) {
        var slice = cnpj.slice(0, x);
        var factor = x - 7;
        var sum = 0;
        for (var i = x; i >= 1; i--) {
            var n = slice.charCodeAt(x - i) - 48;
            sum += n * factor--;
            if (factor < 2)
                factor = 9;
        }
        var result = 11 - (sum % 11);
        return result > 9 ? 0 : result;
    }
});
